import isServer from './isServer';

interface PageMeta {
  title: string | null;
  description: string | null;
  tags: string | null;
  imageUrl: string | null;
}

const setMetaTag = (selector: { name: string; value: string }[], value: string | null) => {
  if (!value) {
    return;
  }

  const propertiesSelector = selector.map((i) => `[${i.name}="${i.value}"]`).join('');
  let el = window.document.querySelector(`meta${propertiesSelector}`);
  if (!el) {
    el = document.createElement('meta') as HTMLElement;
    if (el) {
      selector.forEach((attr) => {
        if (el) {
          el.setAttribute(attr.name, attr.value);
        }
      });

      window.document.head.appendChild(el);
    }
  }

  el.setAttribute('content', value);
};

const setPageMeta = (data: Partial<PageMeta>) => {
  if (!isServer()) {
    if (data.title) {
      window.document.title = data.title;
    }

    data.imageUrl && setMetaTag([{ name: 'property', value: 'og:image' }], data.imageUrl);
    data.imageUrl && setMetaTag([{ name: 'property', value: 'og:image:secure_url' }], data.imageUrl);
    data.title && setMetaTag([{ name: 'property', value: 'og:title' }], data.title);
    data.description && setMetaTag([{ name: 'property', value: 'og:description' }], data.description);
    data.description && setMetaTag([{ name: 'name', value: 'description' }], data.description);
    data.tags && setMetaTag([{ name: 'name', value: 'keywords' }], data.tags);
  }
};

export default setPageMeta;
